export class CuentaBeneficiario {
    BENEFICIARY_BACK_ACCOUNT_ID?: number;
    NAME: string;
    ACCOUNT: string;
    RFC: string;
    COMPANY_ID: number;
    BANK_ID: number;
}


// WEBPACK FOOTER //
// ./src/app/models/cuenta-beneficiario.ts